import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { styled } from '@classify/react-core-components/styles';
import NotStartedSvg from '../../images/course-not-started.svg';
import OneThirdSvg from '../../images/course-one-third.svg';
import TwoThirdsSvg from '../../images/course-two-thirds.svg';
import LastThirdSvg from '../../images/course-last-third.svg';
const IMG_SIZE = 180;
const IMG_SIZE_SMALL = 132;
const ProgressionImage = styled(Image)(({
  theme
}) => ({
  height: IMG_SIZE_SMALL,
  width: IMG_SIZE_SMALL,
  [theme.breakpoints.up('sm')]: {
    height: IMG_SIZE,
    width: IMG_SIZE
  }
}));
export interface ProgressionIllustrationProps {
  progression: number;
}
function ProgressionIllustration(t0) {
  const $ = _c(4);
  const {
    progression
  } = t0;
  if (progression === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProgressionImage src={NotStartedSvg} alt="" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (progression < 33) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProgressionImage src={OneThirdSvg} alt="" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (progression < 66) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProgressionImage src={TwoThirdsSvg} alt="" />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProgressionImage src={LastThirdSvg} alt="" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default ProgressionIllustration;